var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8891 0.898115C17.0002 1.33367 16.1291 1.51056 15.2224 1.77812C14.226 0.653671 12.7487 0.591448 11.3291 1.123C9.90955 1.65456 8.97977 2.95412 9.00022 4.44478V5.33367C6.11577 5.40745 3.54688 4.09367 1.88911 1.77812C1.88911 1.77812 -1.82823 8.38523 5.44466 11.5559C3.78066 12.6643 2.12111 13.4119 0.111328 13.3337C3.05177 14.9363 6.25622 15.4875 9.03044 14.6821C12.2127 13.7577 14.8278 11.3728 15.8313 7.80034C16.1307 6.71382 16.2793 5.59132 16.2731 4.46434C16.2713 4.24301 17.6153 2.00034 17.8891 0.897226V0.898115Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIconGray);
export default __webpack_public_path__ + "static/media/twitterIconGray.9f85ffa5395f33a9f65efb6d364afc17.svg";
export { ForwardRef as ReactComponent };